/**
 * COURE.HUB.DS.USSD.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface USSDCampaignModel { 
    id?: string;
    serviceProviderId?: string;
    serviceId?: string;
    campaignName?: string;
    description?: string;
    status?: boolean;
    shortCode?: string;
    shortCodeKeyNumber?: string;
    dateCreated?: Date;
    dateModified?: Date;
    expiryDate?: Date;
}